import Axios from 'axios';
export default () => {
    return Axios.create({
        baseURL:process.env.VUE_APP_BACKEND_URL,
        /*headers: {
            //Authorization: `Bearer ${store.state.token}`
        }*/
    })   
}
